import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountOperationsQuery($filters: [Filter], $companyId: ID!) {
    Me {
      id
      Company(id: $companyId) {
        data: countFireLoads(options: { filters: $filters })
      }
    }
  }
`
